<template>
<div class="fc-center ca-center"><nav class="fc-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>财务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>金额账户中心</span></nav><header class="fc-heading"><div><h1>金额账户中心</h1><p>管理学员金额余额、充值缴费与账户收支变动</p></div><span class="fc-heading-symbol"><v-icon size="26" color="#d9363e">mdi-cash-multiple</v-icon></span></header><v-tabs class="fc-tabs" v-model="tab" color="#d9363e" background-color="transparent" show-arrows><v-tabs-slider color="#d9363e" /><v-tab>金额账户余额</v-tab><v-tab>充值缴费订单</v-tab><v-tab>手工扣费订单</v-tab><v-tab>金额流水查询</v-tab><v-tab>退费订单查询</v-tab></v-tabs><v-tabs-items class="fc-tab-panels" v-model="tab"><v-tab-item><accountList /></v-tab-item><v-tab-item><cashRecharge /></v-tab-item><v-tab-item><cashReduceOrder /></v-tab-item><v-tab-item><cashJournal /></v-tab-item><v-tab-item><cashRefundOrder /></v-tab-item></v-tabs-items></div>
</template>

<script>
	import global from '../../../config/global'
	import accountList from "./student_cash_list.vue"
	import cashRecharge from "./cash_recharge_list.vue"
	import cashJournal from "./cash_journal_list.vue"
	import cashReduceOrder from "./cash_reduce_order.vue"
	import cashRefundOrder from "./cash_refund_order.vue"
	export default {
		name: "cash-account-index",
		components:{accountList,cashRecharge,cashJournal,cashReduceOrder,cashRefundOrder},
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员金额账户中心',
						disabled: true
					},
				],
				tab:null,
				
				
			}
		},
		created() {
		
		},
		
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/cash-account.scss"></style>
